import React, {useState} from "react";
import InvoiceGeneratorController from "../../../invoiceGenerator/controller/invoiceGeneratorController";
import {Spinner} from "react-bootstrap";
import {useTranslation} from "react-i18next";

export default function TestLocalPrinter() {
    const {t } = useTranslation();
    const [loading, setLoading] = useState(false);

    const handleClick = () => {
        setLoading(true);

        setTimeout(() => {
            new InvoiceGeneratorController().printTest();
            setLoading(false);
        }, 6000);
    };

    return (
        <section className={'local-test-printer'}>
            <div>
                <p>{t("setting.kioskPrinter")}</p>
                <button className={loading ? 'test-printer-loading' : ''} type="submit"
                        onClick={handleClick} disabled={loading}>
                    {loading ? <Spinner/> : t("test")}
                </button>
            </div>
        </section>
    );
}
